export default __webpack_public_path__ + "static/innovative-a2d88fd4237f1ac5c165cd329829a662.svg";